import { markerIcon } from "components/Maps/MarkerIcon";
import Loader from "components/Modals/OccurrenceManagementModal/Loader";
import { IOccurrence } from "interfaces/Occurrence";
import { LatLngTuple } from "leaflet";
import { Ref } from "react";
import { Marker, TileLayer } from "react-leaflet";

import * as S from "./styles";

type OccurrenceMapProps = {
  occurrence: IOccurrence | null;
  map: Ref<L.Map>;
  occurrenceLocation?: LatLngTuple;
  policemanLocation?: LatLngTuple;
};

export default function OccurrenceMap({
  occurrence,
  map,
  occurrenceLocation,
  policemanLocation,
}: OccurrenceMapProps) {
  return (
    <S.MapContentContainer>
      {!occurrence && <Loader color="white" size={90} />}

      <S.Content>
        {occurrence && (
          <S.Container>
            {!!occurrenceLocation && (
              <S.StyledMapContainer
                center={occurrenceLocation}
                zoom={10}
                ref={map}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                {!!policemanLocation && (
                  <Marker
                    icon={markerIcon({
                      color: "black",
                      type: "policemanOnDuty",
                    })}
                    position={{
                      lat: policemanLocation[0],
                      lng: policemanLocation[1],
                    }}
                    eventHandlers={{
                      click: () => {},
                    }}
                  />
                )}

                <Marker
                  icon={markerIcon({
                    color: "white",
                    type: "occPatrimony",
                  })}
                  position={{
                    lat: occurrenceLocation[0],
                    lng: occurrenceLocation[1],
                  }}
                  eventHandlers={{
                    click: () => {},
                  }}
                />
              </S.StyledMapContainer>
            )}
          </S.Container>
        )}
      </S.Content>
    </S.MapContentContainer>
  );
}
